import React from "react";
import {Route} from "react-router-dom";
import * as ROUTES_CONSTANTS from "../../utils/constants/RoutesConstants";
import DetailLoanContainer from "../../pages/controlPanel/detailLoan/DetailLoanContainer";
import TransactionalLogContainer from "../../pages/controlPanel/transactionalLog/TransactionalLogContainer";
import RestrictionGuaranteeSelectionContainer
    from "../../pages/controlPanel/restrictionGuaranteeSelection/RestrictionGuaranteeSelectionContainer";
import BreakLoanContainer from "../../pages/controlPanel/breakLoan/BreakLoanContainer";
import ReturnMaturityContainer from "../../pages/controlPanel/returnMaturity/ReturnMaturityContainer";
import ExcessLoanContainer from "../../pages/controlPanel/excessLoan/ExcessLoanContainer";
import CaptureGuaranteeContainer from "../../pages/controlPanel/captureGuarantee/CaptureGuaranteeContainer";
import MarginCallContainer from "../../pages/controlPanel/marginCall/MarginCallContainer";
import GuaranteeReplacementContainer from "../../pages/controlPanel/guaranteeReplacement/GuaranteeReplacementContainer";
import MoveTitleGuaranteeContainer from "../../pages/controlPanel/moveTitleGuarantee/moveTitleGuaranteeContainer";
import ExtensionLoanContainer from "../../pages/controlPanel/extensionLoan/ExtensionLoanContainer";
import NewLoanContainer from "../../pages/controlPanel/newLoan/newLoanContainer";
import SettleBreakLoanContainer from "../../pages/controlPanel/breakLoan/settle/SettleBreakLoanContainer";

const ControlPanelRoutes = () => {
    return (
        <React.Fragment>
            <Route path={ROUTES_CONSTANTS.CONTROL_PANEL_DETAIL_LOAN_ROUTE} component={DetailLoanContainer}/>
            <Route path={ROUTES_CONSTANTS.CONTROL_PANEL_TRANSACTIONAL_LOG} component={TransactionalLogContainer}/>
            <Route path={ROUTES_CONSTANTS.CONTROL_PANEL_RESTRICTION_GUARANTEE_SELECTION}
                   component={RestrictionGuaranteeSelectionContainer}/>
            <Route path={ROUTES_CONSTANTS.CONTROL_PANEL_BREAK_LOAN} component={BreakLoanContainer}/>
            <Route path={ROUTES_CONSTANTS.CONTROL_PANEL_RETURN_MATURITY} component={ReturnMaturityContainer}/>
            <Route path={ROUTES_CONSTANTS.CONTROL_PANEL_EXCESS_LOAN} component={ExcessLoanContainer}/>
            <Route path={ROUTES_CONSTANTS.CONTROL_PANEL_CAPTURE_GUARANTEE} component={CaptureGuaranteeContainer}/>
            <Route path={ROUTES_CONSTANTS.CONTROL_PANEL_MARGIN_CALL} component={MarginCallContainer}/>
            <Route path={ROUTES_CONSTANTS.CONTROL_PANEL_GUARANTEE_REPLACEMENT}
                   component={GuaranteeReplacementContainer}/>
            <Route path={ROUTES_CONSTANTS.CONTROL_PANEL_MOVE_TITLE_GUARANTEE} component={MoveTitleGuaranteeContainer}/>
            <Route path={ROUTES_CONSTANTS.CONTROL_PANEL_EXTENSION_LOAN} component={ExtensionLoanContainer}/>
            <Route path={ROUTES_CONSTANTS.CONTROL_PANEL_NEW_LOAN} component={NewLoanContainer}/>
            <Route path={ROUTES_CONSTANTS.CONTROL_PANEL_SETTLE_BREACH} component={SettleBreakLoanContainer}/>
        </React.Fragment>
    );
};

export default ControlPanelRoutes;